import Fun from './Fun';
import Growth from './Growth';
import Health from './Health';
import Work from './Work';

const GroupIcons = {
  Fun,
  Growth,
  Health,
  Work,
};

export default GroupIcons;
